import React, { useEffect, useState } from "react";
import ProfileForm from "../components/ProfileForm";
import { getProfile, updateProfile } from "../api/profileApi";
import { ProfileModel } from "../models/ProfileModel";
import { useProfileTheme } from "../components/ProfileThemeProvider";

const Profile = () => {
    const [profile, setProfile] = useState(null as ProfileModel | null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null as string | null);
    const { refreshTheme } = useProfileTheme();

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const data = await getProfile();
                setProfile(data);
            } catch (err) {
                setError("Failed to load profile");
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    const handleProfileUpdate = async (updatedProfile: ProfileModel) => {
        try {
            await updateProfile(updatedProfile);
            setProfile(updatedProfile);
            await refreshTheme();
        } catch (err) {
            setError("Failed to update profile");
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="main-container" style={{ height: "auto" }}>
            <h1>Chat</h1>
            {profile && (
                <ProfileForm profile={profile} onUpdate={handleProfileUpdate} />
            )}
        </div>
    );
};

export default Profile;
